import clsx from 'clsx';
import React from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox';
import { remove } from 'lodash';
const dates = [
  { label: 'MON', value: 0 },
  { label: 'TUE', value: 1 },
  { label: 'WED', value: 2 },
  { label: 'THR', value: 3 },
  { label: 'FRI', value: 4 },
  { label: 'SAT', value: 5 },
  { label: 'SUN', value: 6 },
];
type Props = {
  value?: number[];
  onChange?: (value?: number[]) => void;
};

const DayOfWeek = ({ value, onChange }: Props) => {
  const handleToggle = (o: number) => () => {
    if (value?.includes(o)) {
      const temp = [...value];
      remove(temp, s => s === o);
      onChange?.(temp);
    } else {
      const temp = [...value || []];
      temp.push(o);
      onChange?.(temp);
    }
  };

  return (
    <Container>
      {dates.map(o => (
        <button onClick={handleToggle?.(o.value)} key={o.value} className={clsx('date-item', value?.includes(o.value) && 'active')} type='button'>
          <Checkbox value={value?.includes(o.value)} />
          <span>{o.label}</span>
        </button>
      ))}
    </Container>
  );
};

export default DayOfWeek;
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  button.date-item {
    display: flex;
    height: 56px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #86909C;
    background: #FFF;
    gap: 8px;
    &:active {
      background: #eee;
    }
    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 166.667% */
      text-transform: capitalize;
    }

    &.active {
      border: 1px solid #2D6772;
      background: #F2FEFF;
      span {
        color: #2D6772;
      }
    }
  }
`;